var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 6,
    fill: "#808080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First STAGE"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -775,
    y: -7854,
    width: 28719,
    height: 20976,
    rx: 100,
    fill: "#C9CACB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TP.com > Hustler-Casino-Live-Stream-Poker-Tracker",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3142,
    transform: "translate(-467 -1341)",
    fill: "#F8F9FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 267",
    x: -467,
    y: -241,
    width: 1440,
    height: 1609,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M4.5 6L0.602886 0.75H8.39711L4.5 6Z",
    fill: "#1F2126"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3142,
    fill: "white",
    transform: "translate(-467 -1341)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.addc2a8a401a3aa339a584371a7a0cb1.svg";
export { ForwardRef as ReactComponent };